export default __webpack_public_path__ + "static/media/Gold_Book_C3 (1).91cda4d8.png";